import he from 'he';
import { get, post } from 'lib/actionHelpers.js';

export const fetchCommunicationHistory = ({ leadId, offset, filter }, cb) => {
  const action = !offset ? 'GET_MESSAGES_FOR_CHAT_LEADS' : 'GET_PAGINATED_MESSAGES_FOR_CHAT_LEADS';
  return get(`/lead/${leadId}/communications`, {
    query: {
      offset,
      filter: undefined,
    },
    action,
    callback: cb,
  });
};

export const postTextMessage = (data, callback) => {
  return post(`/lead/${data.leadId}/text`, {
    data: {
      contact_detail_id: data.contactDetailId,
      contact_id: data.contactId,
      service_provider_id: data.serviceProviderId,
      tracked_phone_id: data.trackedPhoneId,
      message: he.decode(data.message),
      file_ids: (data.fileIds || []).length ? data.fileIds : undefined,
    },
    action: 'POST_COMPOSER_MESSAGE',
    callback: callback,
  });
};

export const postReviewLoopText = (data) => {
  return post(`/lead/${data.leadId}/reviewloop`, {
    data: {
      contact_detail_id: data.contactDetailId,
      contact_id: data.contactId,
      service_provider_id: data.serviceProviderId,
      platform_registration_id: data.platformRegistrationId,
      message: he.decode(data.message),
    },
    action: 'POST_COMPOSER_MESSAGE',
    callback: data.callback,
  });
};

export const getReviewLoopMessageStatus = (hash, callback) => {
  return get(`/integration/reviewloop/get-review/${hash}`, {
    action: 'GET_REVIEW_LOOP_MESSAGE_STATUS',
    callback,
  });
};

export const postFacebookMessengerMessage = ({ serviceProviderId, message, platformRegistrationId, serviceLocationId, threadId, leadId, callback }) => {
  return post(`/event/send-messenger`, {
    data: {
      service_provider_id: serviceProviderId,
      message,
      platform_registration_id: platformRegistrationId,
      service_location_id: serviceLocationId,
      thread_id: threadId,
      lead_id: leadId,
    },
    action: 'POST_COMPOSER_MESSAGE',
    callback,
  });
};

export const postInstagramMessage = ({ serviceProviderId, message, platformRegistrationId, serviceLocationId, threadId, leadId, callback }) => {
  return post(`/event/send-messenger`, {
    data: {
      service_provider_id: serviceProviderId,
      message,
      platform_registration_id: platformRegistrationId,
      service_location_id: serviceLocationId,
      thread_id: threadId,
      lead_id: leadId,
    },
    action: 'POST_COMPOSER_MESSAGE',
    callback,
  });
};

export const postPhoneCall = ({ serviceProviderId, leadId, note, contactId, contactDetailId, fromDetailId, manual, callback }) => {
  return post(`/lead/${leadId}/call`, {
    data: {
      contact_detail_id: contactDetailId,
      contact_id: contactId,
      note,
      service_provider_id: serviceProviderId,
      tracked_phone_id: fromDetailId,
      manual: manual,
    },
    action: 'POST_PHONE_CALL',
    callback,
  });
};

export const putMessageStatus = (id, data, callback) => {
  return post(`/event/${id}/change-status`, {
    data,
    callback,
  });
};

export const postExistingCustomerMessageConnection =
  ({ message, lead }, callback) =>
  () => {
    return post(`/event/${message.id}/change-status`, {
      data: {
        event_type: message.type,
        contact_id: lead.primary_contact_id,
        lead_id: lead.id,
        is_unique: '1',
      },
      action: 'POST_EXISTING_CUSTOMER_MESSAGE_CONNECTION',
      callback,
    });
  };

export const patchThreadMeta =
  ({ eventType, eventId, serviceProviderId, firstName, lastName, phone, email }, cb) =>
  () => {
    return post(`/event/update-thread-meta/${eventId}`, {
      data: {
        service_provider_id: serviceProviderId,
        first_name: firstName,
        last_name: lastName,
        event_type: eventType,
        phone: phone,
        email: email,
      },
      action: 'PATCH_THREAD_META',
    });
  };

export const postCallNote = (id, data, callback) => {
  return post(`/event/${id}/change-status`, {
    data,
    action: 'POST_CALL_NOTE',
    callback,
  });
};

export const postFourthDimensionLead = (data, callback) => {
  return post(`/integration/4th-dimension/add-lead`, {
    data,
    action: 'POST_GENERIC_INTEGRATION',
    callback,
  });
};

export const postPatientNowLead = (data, callback) => {
  return post(`/integration/patientnow/add-lead`, {
    data,
    action: 'POST_GENERIC_INTEGRATION',
    callback,
  });
};

export const postEnvisionLead = (data, callback) => {
  return post(`/integration/envision/add-lead`, {
    data,
    action: 'POST_GENERIC_INTEGRATION',
    callback,
  });
};

export const postEnvisionSync = (data, callback) => {
  return post(`/integration/envision/sync`, {
    data,
    callback,
  });
};

export const postEmaLead = (data, callback) => {
  return post(`/integration/ema/add-lead`, {
    data,
    action: 'POST_GENERIC_INTEGRATION',
    callback,
  });
};

export const postNextechLead = (data, callback) => {
  return post(`/integration/nextech/add-lead`, {
    data,
    action: 'POST_GENERIC_INTEGRATION',
    callback,
  });
};

export const postIntakeQLead = (data, callback) => {
  return post(`/integration/intake-q/add-lead`, {
    data,
    action: 'POST_GENERIC_INTEGRATION',
    callback,
  });
};
